import { Flex } from "@components/index";
import { useChannelIcons } from "@src/common/hooks";
import type React from "react";
import { useMemo } from "react";
import FilterAccordion, { type FilterOption } from "../FilterAccordion";

const CHANNEL_OPTIONS = ["TMS", "Revenda", "AS", "CED/CMP"];

interface ChannelsFilterProps {
  selectedFilters: string[];
  onChange: (channel: string, checked: boolean) => void;
}

const ChannelsFilter: React.FC<ChannelsFilterProps> = ({
  selectedFilters,
  onChange,
}) => {
  const { getChannelIconWithNameForFilter } = useChannelIcons();

  const options: FilterOption[] = useMemo(() => {
    return CHANNEL_OPTIONS.map((channel) => {
      const { icon } = getChannelIconWithNameForFilter(channel);
      return {
        value: channel,
        label: (
          <Flex.Row alignItems="center" gap="8px">
            {icon}
            <span>{channel}</span>
          </Flex.Row>
        ),
      };
    });
  }, [getChannelIconWithNameForFilter]);

  return (
    <FilterAccordion
      title="Canais"
      options={options}
      selectedValues={selectedFilters}
      onChange={onChange}
    />
  );
};

export default ChannelsFilter;
